import { render, staticRenderFns } from "./PpdsCaption.vue?vue&type=template&id=2a25a786&"
import script from "./PpdsCaption.vue?vue&type=script&lang=ts&"
export * from "./PpdsCaption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports